export enum CommentTypeEnum {
  REFUND_REASON = "REFUND_REASON",
  REFUND_CANCEL_REASON = "REFUND_CANCEL_REASON"
}